import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";

const Styles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    width: 250,
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: 14,
  }),
};

const ContentTags = ({
  onChangeTags,
  articles = [],
  hotTopicTags = [],
  products = [],
  isVisible,
  currentTags = null,
}) => {
  const [articleTag, setArticleTag] = useState({});
  const [hotTopicTag, setHotTopicTag] = useState({});
  const [productTag, setProductTag] = useState({});

  useEffect(() => {
    if (currentTags) {
      setArticleTag(currentTags.article ? {
        value: currentTags.article.id,
        label: currentTags.article.title,
      } : { label: "No Tag", value: null });
      setHotTopicTag(currentTags.hotTopicTag ? {
        value: currentTags.hotTopicTag.id,
        label: currentTags.hotTopicTag.title,
      } : { label: "No Tag", value: null });
      setProductTag(currentTags.productTag ? {
        value: currentTags.productTag.id,
        label: currentTags.productTag.caption,
      } : { label: "No Tag", value: null });
    } else {
      setArticleTag(null);
      setHotTopicTag(null);
      setProductTag(null)
    }
  }, [currentTags]);

  // useEffect(() => {
  //   onChangeTags({
  //     article: article.value,
  //   });
  // }, [article]);

  const handleSelectArticle = (value) => {
    setArticleTag(value)
    onChangeTags({article: value.value})
  };
  const handleSelectHotTopic = (value) => {
    setHotTopicTag(value)
    onChangeTags({hotTopicTag: value.value})
  };
  const handleSelectProduct = (value) => {
    setProductTag(value)
    onChangeTags({productTag: value.value})
  };
  return (
    <div className={`content-tags ${!isVisible ? "d-none" : ""} mt-3`}>
      {/* {type.value === "streaming" && (
        <p className="add-event-title">Live Stream Event</p>
      )} */}
      {/* <p className="add-event-title">Article</p>
      <div className="form-group">
        <Select
          value={article}
          onChange={(article) => {
            setArticle(article);
            console.log("select", article);
            onChangeTags({
              article,
            });
          }}
          options={[{ label: "No Tag", value: null }].concat(
            articles.map((article) => ({
              value: article.id,
              label: article.title,
            }))
          )}
          styles={Styles}
          placeholder="Tag a article"
          noOptionsMessage={() => "No Tag"}
        ></Select>
      </div> */}
      <div className="form-group row">
        <div className="col-12">
          <div className="form-group row">
            <div className="col-12">
              <ReactSelect
                isSearchable={true}
                value={articleTag}
                onChange={handleSelectArticle}
                options={[{ label: "No Tag", value: null }].concat(
                  articles.map((article) => ({
                    value: article.id,
                    label: article.title,
                  }))
                )}
                placeholder="Tag a article"
                // onInputChange={handleInputArticleChange}
                styles={{
                  option: (provided, state) => ({
                    ...provided,
                    textAlign: "left",
                  }),
                }}
                noOptionsMessage={() => "No Tag"}
              ></ReactSelect>
            </div>
          </div>
          <div className="form-group row">
            <div className="col-12">
              <ReactSelect
                isSearchable={true}
                value={ hotTopicTag }
                onChange={handleSelectHotTopic}
                options={[{ label: "No Tag", value: null }].concat(
                  hotTopicTags.map((hotTopic) => ({
                    value: hotTopic.id,
                    label: hotTopic.title,
                  }))
                )}
                placeholder="Tag a hot topic"
                styles={{
                  option: (provided, state) => ({
                    ...provided,
                    textAlign: "left",
                  }),
                }}
              ></ReactSelect>
            </div>
          </div>
          <div className="form-group row">
            <div className="col-12">
              <ReactSelect
                isSearchable={true}
                value={productTag}
                onChange={handleSelectProduct}
                options={[{ label: "No Tag", value: null }].concat(
                  products.map((product) => ({
                    value: product.id,
                    label: product.caption,
                  }))
                )}
                placeholder="Tag a product"
                // onInputChange={handleInputProductChange}
                styles={{
                  option: (provided, state) => ({
                    ...provided,
                    textAlign: "left",
                  }),
                }}
                noOptionsMessage={() => "No Tag"}
              ></ReactSelect>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentTags;



// WEBPACK FOOTER //
// ./src/screens/Event/components/ContentTags.js